/* MUI */
import { Box, CircularProgress, Typography } from '@mui/material';

/*  Shared  */
import { Modal, ModalBody } from 'application/Shared/Modals';

/*  NPM  */
import { useFetchApplicationDetails } from 'hooks/dataAccess/ApplicationDetails/applicationDetails';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

export const BedrockModal = ({ open, application, closeModal }) => {
    const [details, setDetails] = useState({});
    const { t } = useTranslation();

    const styles = {
        modal: {
            row: {
                // Full Row
                alignItems: 'center',
                display: 'flex',
                marginBottom: '2px',
                padding: '2px'
            },
            styles: {
                // Modal
                height: 'fit-content',
                left: '36%',
                top: '22%',
                width: 'fit-content'
            }
        }
    };

    const props = {
        data: {
            marginRight: '8px',
            padding: '2px',
            width: '80%'
        },
        title: {
            component: 'div',
            variant: 'body1',
            width: '20%'
        }
    };

    const { applicationDetails, loading } = useFetchApplicationDetails(
        open,
        application.id
    );

    useEffect(() => {
        if (loading) setDetails({});
        else setDetails(applicationDetails);
    }, [applicationDetails, loading]);

    const {
        appName,
        appType,
        category,
        description,
        riskScore,
        riskReason,
        subCategory
    } = details;

    const categoryName = `${category} / ${subCategory}`;

    const rows = [
        {
            data: appType,
            title: t('BedrockModal.appType')
        },
        {
            data: appName,
            title: t('BedrockModal.appName')
        },
        {
            data: categoryName,
            title: t('BedrockModal.categoryName')
        },
        {
            data: description,
            title: t('BedrockModal.description')
        },
        {
            data: riskScore,
            title: t('BedrockModal.riskScore')
        },
        {
            data: riskReason,
            title: t('BedrockModal.riskReason')
        }
    ];

    return (
        <Modal
            data-testid="bedrockmodalModal"
            open={open}
            title={`${application.name} (${application.baseName})`}
            titleProps={{ showClose: true, textTransform: 'none' }}
            paperProps={{ minWidth: '600px' }}
            onClose={() => {
                closeModal();
            }}
            sx={styles.modal.styles}
            disableScrollLock
            disableEnforceFocus
            hideBackdrop
            draggable
        >
            <ModalBody data-testid="bedrockmodalModalBody">
                <Box data-testid="bedrockmodalModalBodyWrapper">
                    {!details.description ? (
                        <Box
                            sx={{
                                alignItems: 'center',
                                display: 'flex',
                                height: '200px',
                                justifyContent: 'center'
                            }}
                        >
                            <CircularProgress />
                        </Box>
                    ) : (
                        <Box sx={{ maxHeight: '400px' }}>
                            {rows.map((row) => {
                                const { title, data } = row;
                                return (
                                    <Box sx={styles.modal.row} key={title}>
                                        <Typography
                                            {...props.title}
                                            sx={{ fontWeight: 600 }}
                                        >
                                            {title}
                                        </Typography>
                                        <Typography {...props.data}>
                                            {data}
                                        </Typography>
                                    </Box>
                                );
                            })}
                        </Box>
                    )}
                </Box>
            </ModalBody>
        </Modal>
    );
};
